import type { IconProps as DSIconProps } from '@eqi-investimentos/react';
import type { FC } from 'react';
import * as EQIIcons from '@eqi-investimentos/icons/web';
import type { IconsNames } from '@eqi-investimentos/icons/web';

export const Icon: FC<IconProps> = ({
  iconName,
  className = '',
  width = 8,
  height = 8,
  ...props
}) => {
  const hasIcon = Object.keys(EQIIcons).includes(iconName ?? '');

  if (!hasIcon) return <></>;

  const CustomIcon = EQIIcons[iconName ?? 'Add'];
  if (typeof CustomIcon !== 'function')
    return (
      <EQIIcons.Warning
        data-testid={iconName}
        className={className}
        width={width}
        height={height}
        {...props}
      />
    );
  return (
    <CustomIcon
      data-testid={iconName}
      className={className}
      width={width}
      height={height}
      {...props}
    />
  );
};

export type IconProps =
  | (Omit<
      DSIconProps,
      'className' | 'width' | 'height' | 'color' | 'children'
    > & {
      iconName: IconsNames;
      className?: string;
      width?: number | `${number}px`;
      height?: number | `${number}px`;
      color?: string;
    })
  | {
      iconName?: IconsNames;
      className?: string;
      width?: number | `${number}px`;
      height?: number | `${number}px`;
      color?: string;
    };
